import { useState } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Proof } from "@/components/Proof";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Work } from "@/components/Work";
import { Reviews } from "@/components/Reviews";
import { Locations } from "@/components/Locations";
import { Enquiry } from "@/components/Enquiry";
import { Footer } from "@/components/Footer";
import { MobileBookBar } from "@/components/MobileBookBar";
import { BookingDialog } from "@/components/BookingDialog";
import { OfferFlyer } from "@/components/OfferFlyer";
import { useSeo } from "@/hooks/useSeo";
import { siteUrl } from "@/data/site";

export default function Landing() {
  const [booking, setBooking] = useState(false);
  const open = () => setBooking(true);

  useSeo({
    title:
      "The Vault Barber Co | #1 Barber Shop in Argyle & Lantana, TX",
    description:
      "Top-rated barbers in Argyle & Lantana, TX · 4.9★ from 403+ reviews. Skin fades, beard sculpting, hot towel shaves. Open daily 8AM-7PM — walk in today.",
    canonical: siteUrl("/"),
  });

  return (
    <div className="min-h-screen bg-[#0a0d12]">
      <SmoothScroll />
      <Header onBook={open} />
      <main>
        <Hero onBook={open} />
        <Marquee testId="marquee-primary" />
        <Proof />
        <Manifesto />
        <Services onBook={open} />
        <Work />
        <Marquee testId="marquee-secondary" />
        <Reviews />
        <Locations />
        <Enquiry />
      </main>
      <Footer onBook={open} />
      <MobileBookBar />
      <OfferFlyer />
      <BookingDialog open={booking} onClose={() => setBooking(false)} />
    </div>
  );
}
